<template>
  <div class="wrapper">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button v-if="searchStatus" status="my-orange" @click="searchStatus = false">隐藏查询</vxe-button>
        <vxe-button v-if="!searchStatus" status="my-orange" icon="fa fa-search" @click="searchStatus = true">查询</vxe-button>
      </template>
    </vxe-toolbar>
    <div v-if="searchStatus" class="search">
      <vxe-form title-align="right" title-width="120" title-colon :data="listQuery" @submit="handleSearch(true)" @reset="handleSearch(true, true)">
        <vxe-form-item title="名称" span="6">
          <vxe-input v-model="listQuery.param.name" placeholder="请输入名称" clearable />
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <vxe-button type="submit" status="my-orange" icon="fa fa-check">应用</vxe-button>
          <vxe-button type="reset" status="my-orange" icon="fa fa-undo">重置</vxe-button>
        </vxe-form-item>
      </vxe-form>
    </div>
    <CustomList ref="CustomList" :columns="tableColumns" :list-query="listQuery" @getList="getList">
      <CustomPic slot="photo" slot-scope="{row}" :src="row.photo || ''" :src-list="[row.photo]" />
      <template slot="operating" slot-scope="{row}">
        <el-button v-permission="'AuditNursingHomeCheckButton'" size="small" type="text" @click="handleDetail(row.id)">查看</el-button>
        <el-button v-permission="'AuditNursingHomePassButton'" size="small" type="text" @click="handlePass(row.id)">通过</el-button>
        <el-button v-permission="'AuditNursingHomeRejectButton'" size="small" type="text" @click="handleRejectAudit(row.id)">拒绝</el-button>
      </template>
    </CustomList>
    <Form ref="Form" />
    <el-dialog
      title="添加登录账号"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <CustomForm
        ref="CustomForm"
        :form-model="formModel"
        :form-items="formItem"
        :form-rules="formRules"
      />
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePassAudit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomList from '@/components/CustomList/index'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'
import { mapActions } from 'vuex'
import Form from '@/views/Pages/nursingHome/nursingHome/components/form'
import CustomForm from '@/components/CustomForm/index.vue'
export default {
  name: 'NursingHome',
  components: { CustomForm, Form, CustomList, ...CustomTemplate },
  data() {
    return {
      searchStatus: false,
      listQuery: {
        param: {
          hasTenant: true,
          status: 0
        }
      },
      tableColumns: [
        {
          prop: 'name',
          title: '名称',
          minWidth: 200
        },
        {
          title: '图片',
          slot: 'photo'
        },
        {
          prop: 'address',
          title: '详细地址',
          minWidth: 200
        },
        {
          title: '负责人信息',
          formatter: (row, column) => {
            let text = row.contactPerson || ''
            text += row.contactPerson && row.contactPhone ? ' <br/> ' : ''
            text += row.contactPhone || ''
            return text
          },
          minWidth: 150
        },
        {
          title: '价格',
          formatter: (row, column) => {
            const priceStart = row.priceStart > 0 ? Number(row.priceStart) : 0
            const priceEnd = row.priceEnd > 0 ? Number(row.priceEnd) : 0
            if (priceStart === priceEnd) {
              if (priceStart > 0) {
                return `${priceStart} 元`
              } else {
                return '-'
              }
            } else {
              return `${priceStart} ～ ${priceEnd} 元`
            }
          },
          minWidth: 150
        },
        {
          title: '操作',
          fixed: 'right',
          slot: 'operating',
          minWidth: 150
        }
      ],
      dialogVisible: false,
      formModel: {
        mainId: '',
        account: '',
        password: '',
        status: 1
      }
    }
  },
  computed: {
    formItem() {
      return {
        'account': {
          'elColSpan': 24,
          'component': 'CustomFormText',
          'label': '账号',
          'maxlength': 50
        },
        'password': {
          'elColSpan': 24,
          'component': 'CustomFormText',
          'label': '密码',
          'maxlength': 50
        }
      }
    },
    formRules() {
      return {
        account: [
          { required: true, message: '账号不能为空', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['nursingHomePublicPageList', 'auditAudit']),
    handleSearch(resetCurrentPage = false, resetSearch = false) {
      if (resetSearch) {
        Object.assign(this.listQuery, this.$options.data.call(this).listQuery)
      }
      this.customListGetList(resetCurrentPage)
    },
    customListGetList(resetCurrentPage = false) {
      this.$refs.CustomList.getList(resetCurrentPage)
    },
    getList(params, callback) {
      this.nursingHomePublicPageList(params).then(response => {
        callback(response)
      }).catch(() => {})
    },
    handleDetail(id) {
      this.$refs.Form.handleDetail(id)
    },
    handlePass(mainId) {
      this.formModel.mainId = mainId
      this.formModel.account = ''
      this.formModel.password = ''
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.CustomForm.$refs.form.clearValidate()
      })
    },
    handlePassAudit() {
      this.requestApi(this.formModel)
      this.dialogVisible = false
    },
    handleRejectAudit(mainId) {
      this.$confirm('确认拒绝吗？', '', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showInput: true
      }).then(data => {
        let reason = ''
        if (typeof data === 'object' && 'value' in data) {
          reason = data.value
        }
        this.requestApi({ reason, mainId, status: 2 })
      }).catch(() => {})
    },
    requestApi(params) {
      params['type'] = 0
      this.auditAudit(params).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('操作成功')
        this.handleSearch(true)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper{
    overflow: auto;
  }
</style>
